import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchDashboardNotes, createDashboardNote, deleteDashboardNote } from "../../../service/api";

export const getNotes = createAsyncThunk("notes/getAll", async (_, { rejectWithValue }) => {
    try {
        const res = await fetchDashboardNotes();
        return res.data;
    } catch (e) {
        return rejectWithValue(e.response?.data || e.message);
    }
});

export const addNote = createAsyncThunk("notes/add", async (data, { rejectWithValue }) => {
    try {
        const res = await createDashboardNote(data);
        return res.data;
    } catch (e) {
        return rejectWithValue(e.response?.data || e.message);
    }
});

export const removeNote = createAsyncThunk("notes/remove", async (id, { rejectWithValue }) => {
    try {
        await deleteDashboardNote(id);
        return id;
    } catch (e) {
        return rejectWithValue(e.response?.data || e.message);
    }
});

const notesSlice = createSlice({
    name: "notes",
    initialState: { notes: [], isLoading: false, actionLoader: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNotes.pending, (state) => { state.isLoading = true; state.error = null; })
            .addCase(getNotes.fulfilled, (state, action) => { state.isLoading = false; state.notes = action.payload.data || []; })
            .addCase(getNotes.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })

            .addCase(addNote.pending, (state) => { state.actionLoader = true; })
            .addCase(addNote.fulfilled, (state, action) => { state.actionLoader = false; state.notes.unshift(action.payload.data); })
            .addCase(addNote.rejected, (state, action) => { state.actionLoader = false; state.error = action.payload; })

            .addCase(removeNote.pending, (state) => { state.isLoading = true; })
            .addCase(removeNote.fulfilled, (state, action) => { state.isLoading = false; state.notes = state.notes.filter(n => n._id !== action.payload); })
            .addCase(removeNote.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
    }
});

export default notesSlice.reducer;
